import { atom } from 'jotai';
import { BETFillList } from '../pages/BETFillListContext';

export enum BETFillListItemChange {
  Up = 'Up',
  Down = 'Down',
  Neutral = 'Neutral',
}

export const betTradesAtom = atom<BETFillList>({ isLoading: true });
